import {
  FlowFormBlockPracticeType,
  FlowFormBlockProviderType,
  FlowFormBlockSchedulingConfigsState,
} from 'flow-schema';

export function getDefaultSchedulingConfigs() {
  return {
    schedulingConfigsState: FlowFormBlockSchedulingConfigsState.Disabled,
    practiceType: FlowFormBlockPracticeType.StaticList,
    practiceIds: [],
    providerType: FlowFormBlockProviderType.StaticList,
    providerIds: [],
    fhirDynamicProviders: [],
    scheduleAppointmentCallSectionEnabled: false,
    scheduleAppointmentCommentEnabled: false,
  };
}
